<qpx-dialog-content contentClass="flex-1! overflow-hidden! p-0!">
    <qpx-file-preview
        [previewUrl]="source().previewUrl"
        [fileName]="source().fileName"
        [initialPage]="source().initialPage"
        [searchTerm]="source().searchTerm"
        [actions]="actions()"
        [panels]="panelContent().panels ?? []"
        [infoPanel]="panelContent().infoPanel"
        (closePreview)="close()"
    />
</qpx-dialog-content>
